import { Link, useLocation } from "react-router-dom";
import { X, Scale } from "lucide-react";
import { useCompare } from "../context/CompareContext";
import { img } from "../lib/api";

export default function CompareTray() {
  const { items, remove, clear } = useCompare();
  const { pathname } = useLocation();
  if (!items.length || pathname === "/compare") return null;
  return (
    <div data-testid="compare-tray" className="fixed bottom-4 inset-x-0 mx-auto z-50 w-[calc(100%-2rem)] max-w-2xl rounded-2xl bg-[#12141c]/95 backdrop-blur-xl border border-[#ff5500]/40 shadow-2xl p-3 flex items-center gap-3 rise">
      <Scale size={18} className="text-[#ff5500] shrink-0 hidden sm:block" />
      <div className="flex gap-2 flex-1 min-w-0 overflow-x-auto no-scrollbar">
        {items.map((p) => (
          <div key={p.id} className="relative shrink-0" data-testid={`compare-tray-item-${p.id}`}>
            <img src={img(p.images[0])} alt={p.title} title={p.title} className="w-12 h-12 rounded-lg object-cover" />
            <button onClick={() => remove(p.id)} data-testid={`compare-tray-remove-${p.id}`} className="absolute -top-1.5 -right-1.5 bg-black rounded-full p-0.5"><X size={12} /></button>
          </div>
        ))}
        {Array.from({ length: 3 - items.length }).map((_, i) => <div key={i} className="w-12 h-12 rounded-lg border border-dashed border-white/15 shrink-0" />)}
      </div>
      <button onClick={clear} data-testid="compare-tray-clear" className="text-xs text-slate-400 hover:text-white">Clear</button>
      {items.length < 2 ? (
        <button disabled data-testid="compare-tray-go" title="Add one more product to compare" className="px-4 py-2.5 rounded-full font-semibold text-sm whitespace-nowrap bg-white/10 text-slate-400 cursor-not-allowed">Compare ({items.length})</button>
      ) : (
        <Link to="/compare" data-testid="compare-tray-go" className="px-4 py-2.5 rounded-full font-semibold text-sm whitespace-nowrap bg-[#ff5500] btn-glow">Compare ({items.length})</Link>
      )}
    </div>
  );
}
